import { CommonModule } from '@angular/common';
import { Component, ElementRef, QueryList, ViewChildren } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router, RouterModule } from '@angular/router';
import { ToastService } from '../../shared/services/toast.service';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AuthService } from '../auth.service';
import { interval, Subscription, takeWhile } from 'rxjs';

@Component({
    selector: 'app-forget-password',
    imports: [CommonModule, RouterModule,ReactiveFormsModule,NgbModule],
    templateUrl: './forget-password.component.html',
    styleUrls: ['./forget-password.component.scss']
})
export class ForgetPasswordComponent {
  @ViewChildren('otpInput') otpInputs!: QueryList<ElementRef>;
  resetForm: FormGroup;
  otpForm: FormGroup;
  passwordForm: FormGroup;
  show: boolean = false;
  OTPInput: boolean = false;
  SetPassword: boolean = false;
  HideNumber:boolean = false
  counter: number = 5;
  private timerSub?: Subscription;
  sendOtpButton: boolean = false;
  constructor(private fb: FormBuilder, public router: Router,private auth:AuthService,private toastService:ToastService) {
    this.resetForm = this.fb.group({
      UserName: ['', Validators.required]
    });

    this.otpForm = this.fb.group({
      otp0: [''],
      otp1: [''],
      otp2: [''],
      otp3: ['']
    });

    this.passwordForm = this.fb.group(
      {
        newPassword: [
          '', 
          [
            Validators.required,
            Validators.minLength(3),
            Validators.maxLength(20),
            Validators.pattern(/^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{3,20}$/) // Ensures at least 1 letter, 1 digit, and 1 special character
          ]
        ],
        confirmPassword: [
          '', 
          [
            Validators.required,
            Validators.minLength(3),
            Validators.maxLength(20),
            Validators.pattern(/^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{3,20}$/) // Ensures same conditions for confirmation password
          ]
        ]
      },
      { validators: this.passwordsMatchValidator } // Apply custom validator
    );
    
  }

  ngOnInit(): void {}

  otpValue: string = ''; // Store the OTP as a single string

  moveToNext(event: any, index: number): void {
    const input = event.target as HTMLInputElement;
  
    // Move focus to next input if current is filled
    if (input.value.length === 1 && index < this.otpInputs.length - 1) {
      this.otpInputs.toArray()[index + 1].nativeElement.focus();
    }
  
    // Concatenate OTP values
    setTimeout(() => {
      this.otpValue = Object.values(this.otpForm.value).join('');
      //console.log(this.otpValue);
      
      // Check if all fields are filled
      if (this.otpValue.length === 4) {
        this.verifyOTP();
      }
    }, 100);
  }
  
  sendOTP() {
     if (this.resetForm.valid) {
      const formData = new FormData();
      const username = this.resetForm.value.UserName;
      formData.append('username', username);
      if (username === null) {
        this.toastService.showToast('Please provide a Username','colored',5000,'danger')
        return
      }
      this.auth.forgotPassword(formData).subscribe({
        next:(response) =>{
          this.OTPInput = true;
          // this.HideNumber = true;
        // console.log('OTP sent successfully', response);
          this.toastService.showToast('OTP has been sent on the given Number','colored',5000,'success')
          this.startCountdown();
          this.sendOtpButton = true;
          
        }
      })
     
    }
  }
  verifyOTP() {
    if (this.otpForm.valid) {
      const formData = new FormData();
      formData.append('username', this.resetForm.value.UserName);
      formData.append('otp', (this.otpForm.value.otp0+this.otpForm.value.otp1+this.otpForm.value.otp2+this.otpForm.value.otp3));
      this.auth.otpVerify(formData).subscribe({ 
        next:(response) =>{
          this.OTPInput = false;
          this.HideNumber = true;
          this.SetPassword = true;  
        // console.log('OTP verified successfully', response);
          this.toastService.showToast('OTP verified successfully','colored',5000,'success')
        },
        error: (err) => {
          console.error('OTP verification failed', err.error.Message);
          this.toastService.showToast(err.error.Message, 'colored', 5000, 'danger');
        }
      })
    }
  }

  passwordsMatchValidator(form: FormGroup) {
    const newPassword = form.get('newPassword')?.value;
    const confirmPassword = form.get('confirmPassword')?.value;
    return newPassword === confirmPassword ? null : { passwordsMismatch: true };
  }
  
  resetPassword() {
    if (this.passwordForm.invalid) {
      this.toastService.showToast('Please fill all fields correctly', 'colored', 5000, 'danger');
      return;
    }
  
    if (this.passwordForm.hasError('passwordsMismatch')) {
      this.toastService.showToast('Passwords do not match', 'colored', 5000, 'danger');
      return;
    }
    const formData = new FormData();
    formData.append('username', this.resetForm.value.UserName);
    formData.append('password', this.passwordForm.value.newPassword);
    this.auth.resetPassword(formData).subscribe({ 
      next:(response) =>{
      // console.log('Password reset successfully', this.passwordForm.value);
      this.toastService.showToast('New Password Set', 'colored', 5000, 'success');
      this.router.navigate(['/auth/login']);
      },
      error: (err) => {
        this.toastService.showToast(err.error.Message, 'colored', 5000, 'danger');
      }
    })
  }
  
  resendOtp(){
    const formData = new FormData();
    formData.append('username', this.resetForm.value.UserName);
    this.auth.resendVerify(formData).subscribe({ 
      next:(response) =>{
        this.toastService.showToast('OTP Send successfully','colored',5000,'success')
        this.startCountdown();
        this.sendOtpButton = true;
      },
      error: (err) => {
        console.error('OTP verification failed', err.error.Message);
        this.toastService.showToast(err.error.Message, 'colored', 5000, 'danger');
      }
    })

  }
  startCountdown() {
    this.counter = 60;
    this.timerSub = interval(1000)
      .pipe(takeWhile(() => this.counter > 0))
      .subscribe(() => this.counter--);
  }

  ngOnDestroy() {
    this.timerSub?.unsubscribe();
  }
  
  showPassword() {
    this.show = !this.show;
  }
}
